// pretty loose way to check this, but it should do the trick. Asset urls take protocol relatively, so check for //
export const isExternalUrl = s =>
  s && (/(http(s?)):\/\//i.test(s) || !s.indexOf('www.') || !s.indexOf('//'))

export const isAnchorLink = s => (s || '').startsWith('#')
